import React from 'react'
import './Footer.css'
import WaveImg from '../../img/wave.png'
import Github from '@iconscout/react-unicons/icons/uil-github'
import LinkedIN from '@iconscout/react-unicons/icons/uil-linkedin'
import WhatsApp from '@iconscout/react-unicons/icons/uil-whatsapp'


function Footer() {
  return (
    <div className='footer'>
        <div className='blur f-blur1' style={{background: "var(--purple)"}}>
        </div>
        <div className='blur f-blur2' style={{background: "#C1F5FF"}}>
        </div>
        <img src={WaveImg} alt="wave" style={{width: '100%'}} />
        <div className='f-content'>
            <span>niketan.kcn@gmail.com</span>
            <div className="f-icons">
                <a href='https://github.com/niketan124'><Github color='white' size='3rem' /></a>
                <a href='https://www.linkedin.com/in/chandra-niketan-9163ab213?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BJia8Pq0mR7inxCdDalf%2Beg%3D%3D'><LinkedIN color='white' size='3rem' /></a>
                <a target='top' href='https://api.whatsapp.com/send?phone=9110389282'><WhatsApp color='white' size='3rem' /></a>
            </div>
            <span>&copy; {new Date().getFullYear()} Niketan</span>
        </div>
    </div>
  )
}

export default Footer